import { createEntityAdapter,EntityState } from '@ngrx/entity';
import { createReducer,on } from '@ngrx/store';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { TrustedDeviceEntity } from '../../entities/trusted-device.entity';
import { TrustedDeviceActions } from '../actions/trusted-devices.actions';

export const TRUSTED_DEVICE_FEATURE_KEY = 'trustedDevice';

export interface TrustedDeviceState extends EntityState<TrustedDeviceEntity> {
    fetched: boolean;
}

const adapter = createEntityAdapter<TrustedDeviceEntity>({
    selectId: Entity => Entity.Id,
});

const initialState: TrustedDeviceState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const trustedDeviceReducer = createReducer(
    initialState,
    on(TrustedDeviceActions.loadsuccess, (state, { Payload }) =>
        adapter.setAll(Payload, {
            ...state,
            fetched: true,
        }),
    ),
    on(TrustedDeviceActions.deletesuccess, (state, { Payload }) =>
        adapter.removeOne(Payload, state),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllTrustedDevice = selectAll;
export const selectTrustedDeviceEntities = selectEntities;

export const selectTrustedDeviceFetched = (state: TrustedDeviceState) => state.fetched;
